import { render, staticRenderFns } from "./lowerSecondarySchool.vue?vue&type=template&id=749143da&"
import script from "./lowerSecondarySchool.vue?vue&type=script&lang=js&"
export * from "./lowerSecondarySchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports